import {fetch_retry_post, fetch_retry_put } from "../redux/actions/ApiManager";
import { getEnv } from "../enviroment";
const { base } = getEnv();

const getTotalDownloads = async(payload) =>  {
  try {
    let response = await fetch_retry_post(`${base}/epms/getOverallStatistics`,payload);
    if (response.status === 200 || response.status === 201) {
      return { success: true, data:response.data };
    } else {
      return { success: false, message:response.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message:error.data };
  }
};

const getTotalCampaign = async(payload) =>  {
  try {
    let response = await fetch_retry_post(`${base}/epms/downlodsByCampaign`,payload);
    if (response.status === 200 || response.status === 201) {
      return { success: true, data:response.data };
    } else {
      return { success: false, message:response.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message:error.data };
  }
};

const getTotalPosition = async(payload) =>  {
  try {
    let response = await fetch_retry_post(`${base}/epms/downlodsByPosition`,payload);
    if (response.status === 200 || response.status === 201) {
      return { success: true, data:response.data };
    } else {
      return { success: false, message:response.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message:error.data };
  }
};

const getTopDownloads = async(payload) =>  {
  try {
    let response = await fetch_retry_post(`${base}/epms/getTopDownloadsByUser`,payload);
    if (response.status === 200 || response.status === 201) {
      return { success: true, data:response.data };
    } else {
      return { success: false, message:response.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message:error.data };
  }
};

const getDownlodsBySite= async(payload) =>  {
  try {
    let response = await fetch_retry_post(`${base}/epms/downlodsBySite`,payload);
    if (response.status === 200 || response.status === 201) {
      return { success: true, data:response.data };
    } else {
      return { success: false, message:response.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message:error.data };
  }
};

const getRecentActivity= async(payload) =>  {
  try {
    let response = await fetch_retry_post(`${base}/epms/getRecentActivity`,payload);
    if (response.status === 200 || response.status === 201) {
      return { success: true, data:response.data };
    } else {
      return { success: false, message:response.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message:error.data };
  }
};

const getRecentDownloadReasons= async(payload) =>  {
  try {
    let response = await fetch_retry_post(`${base}/epms/getRecentDownloadReasons`,payload);
    if (response.status === 200 || response.status === 201) {
      return { success: true, data:response.data };
    } else {
      return { success: false, message:response.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message:error.data };
  }
};

export const dashboard = {
    getTotalDownloads,
    getTotalCampaign,
    getTotalPosition,
    getTopDownloads,
    getDownlodsBySite,
    getRecentActivity,
    getRecentDownloadReasons
  };
    